import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { ColDef, GridApi, GridReadyEvent, RowEditingStartedEvent, RowEditingStoppedEvent } from 'ag-grid-community';
import {AgGridModule} from "ag-grid-angular";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";

@Component({
    selector: 'app-tag-manager-dialog',
    templateUrl: './tag-manager-dialog.component.html',
    styleUrls: ['tag-manager-dialog.component.scss'],
    standalone: true,
    imports: [
        AgGridModule,
        MatDialogModule,
        FormsModule,
        MatButtonModule,
        MatInputModule
    ]
})
export class TagManagerDialogComponent {
    columnDefs: ColDef[] = [
        {
            headerName: 'Tag',
            field: 'tag',
            editable: true,
            filter: 'agTextColumnFilter',
            sortable: true,
            flex: 1,
            cellEditor: 'agTextCellEditor'
        },
        {
            headerName: 'Actions',
            field: 'actions',
            cellRenderer: params => {
                return `
          <button class="ag-btn ag-btn-edit" data-action="edit">✏️</button>
          <button class="ag-btn ag-btn-remove" data-action="remove">🗑️</button>
        `;
            },
            editable: false,
            filter: false,
            sortable: false,
            width: 120
        }
    ];

    defaultColDef: ColDef = {
        resizable: true,
        filter: true,
        sortable: true,
        floatingFilter: true
    };

    rowData: any[] = [];
    gridApi!: GridApi;
    newTag: string = '';

    constructor(
        public dialogRef: MatDialogRef<TagManagerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.rowData = (data.tags || []).map((tag: string) => ({ tag }));
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
    }

    onCellClicked(event: any) {
        if (event.colDef.field === 'actions') {
            const action = event.event.target.getAttribute('data-action');
            if (action === 'edit') {
                this.gridApi.startEditingCell({ rowIndex: event.rowIndex, colKey: 'tag' });
            } else if (action === 'remove') {
                this.rowData.splice(event.rowIndex, 1);
                this.gridApi.setRowData(this.rowData);
            }
        }
    }

    addNewTag() {
        if (this.newTag.trim()) {
            this.rowData.push({ tag: this.newTag.trim() });
            this.gridApi.setRowData(this.rowData);
            this.newTag = '';
        }
    }

    onSave() {
        this.dialogRef.close(this.rowData.map(row => row.tag).filter((tag: string) => tag.trim() !== ''));
    }

    onCancel() {
        this.dialogRef.close();
    }
}
